/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function TextCursorInputIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="text-cursor-input"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M9.627 16.5L9.627 7.5" data-tinysvg-shape="line" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M9.627 7.5A3.128 3.128 0 0 1 11.627 4.5" data-tinysvg-shape="arc" data-tinysvg-arc="12.754 7.418 3.128 3.128 178.496 248.884 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M7.627 4.5A3.128 3.128 0 0 1 9.627 7.5" data-tinysvg-shape="arc" data-tinysvg-arc="6.5 7.418 3.128 3.128 291.116 361.504 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M11.627 19.5A3.128 3.128 0 0 1 9.627 16.5" data-tinysvg-shape="arc" data-tinysvg-arc="12.754 16.582 3.128 3.128 111.116 181.504 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M9.627 16.5A3.128 3.128 0 0 1 7.627 19.5" data-tinysvg-shape="arc" data-tinysvg-arc="6.5 16.582 3.128 3.128 358.496 428.884 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M7 8.5L5.5 8.5C4.395 8.5 3.5 9.395 3.5 10.5L3.5 13.5C3.5 14.605 4.395 15.5 5.5 15.5L7 15.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 8.5L18.5 8.5C19.605 8.5 20.5 9.395 20.5 10.5L20.5 13.5C20.5 14.605 19.605 15.5 18.5 15.5L12 15.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
